import BeneficiariesTable from "./BeneficiariesTable";

export type { BeneficiariesTableHandle } from "./BeneficiariesTable";
export default BeneficiariesTable;
